import deliveryMethods from '../mixins/delivery-methods'

export default {
  methods: {
    /**
     * cognitoにサインイン要求を行う
     * @param {*} userId ユーザーID
     * @param {*} password パスワード
     * @returns cognito ユーザー情報
     */
    signIn: async function (userId, password) {
      const result = await this.$Amplify.Auth.signIn(userId, password).catch(
        (err) => {
          return err
        }
      )
      return result
    },

    /**
     * cognitoにサインアウト要求を行う
     */
    signOut: async function () {
      try {
        await this.$Amplify.Auth.signOut()
      } catch (error) {
        console.log('error signing out: ', error)
      }
    },

    /**
     * 初回認証時のパスワード変更要求を行う
     * @param {*} cognitoUserObject cognito ユーザー情報
     * @param {*} newPassword 新パスワード
     * @returns 要求結果
     */
    requestNewPassword: async function (cognitoUserObject, newPassword) {
      const result = await this.$Amplify.Auth.completeNewPassword(
        cognitoUserObject, // the Cognito User Object
        newPassword // the new password
        // OPTIONAL, the required attributes
      )

      console.log('Request NewPassword Result: ', result)
      return result
    },
    /**
     * ログイン中判定
     */
    isLogin () {
      if (sessionStorage && Object.prototype.hasOwnProperty.call(sessionStorage, deliveryMethods.USER_SESSION_SAVE_KEY)) {
        var account = JSON.parse(sessionStorage.getItem(deliveryMethods.USER_SESSION_SAVE_KEY))
        return account
      }
      return false
    },
    /**
     * セッションストレージからログイン中のユーザーIDの取得を行う
     * @returns 
     */
    getUserId () {
      var account = JSON.parse(sessionStorage.getItem(deliveryMethods.USER_SESSION_SAVE_KEY));
      return account ? account.login_id : null;
    },

    //#region 初回パスワード設定で使用
    /**
     * ユーザーIDをセッションストレージに格納する
     * @param {*} loginUserObj ユーザーID
     */
    saveLoginUserIdToSessionStorage (userId) {      
      sessionStorage.setItem(deliveryMethods.SESSION_STORAGE_SAVE_KEY_LOGIN_USER_OBJ, userId);
    },
    /**
     * セッションストレージからユーザーIDの取得を行う
     * @returns ユーザーID
     */
    getLoginUserIdForSessionStorage () {
      return sessionStorage.getItem(deliveryMethods.SESSION_STORAGE_SAVE_KEY_LOGIN_USER_OBJ);      
    },
    /**
     * セッションストレージに格納されているユーザーIDの削除を行う
     */
    deleteLoginUserIdOfSessionStorage () {
      sessionStorage.removeItem(deliveryMethods.SESSION_STORAGE_SAVE_KEY_LOGIN_USER_OBJ);
    },
    //#endregion

    /**
     * cognitoのカスタム属性であるクリニックコードの更新を行う
     * @param {*} clinicCodes クリニックコード(文字列)
     */
    updateClinicCodeOfCognito: async function (clinicCodes) {
      const user = await this.$Amplify.Auth.currentAuthenticatedUser();
      const attributes = {
        'custom:clinic_code': clinicCodes,
      };

      try {
        await this.$Amplify.Auth.updateUserAttributes(user, attributes);
        console.log("カスタム属性の更新が完了しました");
      } catch (error) {
        console.log("カスタム属性の更新に失敗しました: ", error.message);
      }
    },
    /**
     * Cognitoからカスタム属性のクリニックコードの取得を行う
     * @returns クリニックコード
     */
    getClinicCodeForCognito: async function () {                   
      try {
        const user = await this.$Amplify.Auth.currentAuthenticatedUser();        
        const clinicCode = user.attributes['custom:clinic_code'];        
        return clinicCode;
      } catch (error) {
        console.log("Cognitoからクリニックコードの取得失敗: ", error.message);
      }
      return null;
    },
    
    /**
     * Cognito(AWS)へのアクセスが可能かを判定し返却を行う
     * ※共通部品のヘッダーが毎回Cognitoからクリニックコードを呼び出すので、
     * ログインしていない画面だと画面遷移した際に認証情報がなくログイン画面に戻ってしまう
     * それを防ぐための処理
     * @returns 
     */
    canAccessToCognito () {
      const path = this.$route.fullPath;      
      // メールのリンクからページが開かれた場合
      if (path.startsWith("/reregistration")) {        
        return false;
      }

      // ルーティングでページ移動した場合
      switch (path) {
        case '/login':
        case '/mailsending':
        case '/reregistration':
        case '/passwordSetting':
          return false;
        default:
          return true;
      }      
    },
    /**
     * 利用規約同意済みかの判定を行う
     */
    isAgreedTerms () {
      if (sessionStorage && Object.prototype.hasOwnProperty.call(sessionStorage, deliveryMethods.USER_SESSION_SAVE_KEY)) {
        var account = JSON.parse(sessionStorage.getItem(deliveryMethods.USER_SESSION_SAVE_KEY))
        if (account) {
          switch (deliveryMethods.DOMAIN) {
            case deliveryMethods.DOMAIN_A_SITE:
              return account.is_agreed_terms_a === 1
            case deliveryMethods.DOMAIN_B_SITE:
              return account.is_agreed_terms_b === 1
            case deliveryMethods.DOMAIN_C_SITE:
              return account.is_agreed_terms_c === 1
            default:
              throw new Error('Error Inappropriate value')
          }
        }
      }
    },
    /**
     * ログイン済みかつ利用規約同意済みを表す
     * @returns
     */
    isAcceptedTermOfUse () {
      return (this.isLogin() && this.isAgreedTerms());
    }
  }
}



// WEBPACK FOOTER //
// ./src/mixins/AuthUtil.js